import {catchError, EMPTY, finalize, map, Observable, Subject, takeUntil, throwError} from 'rxjs';
import {IdBase} from '../interfaces';
import {IsLoadingData} from './is-loading.data';

export abstract class AllRequestData<Item extends IdBase<IdType>, IdType = number> extends IsLoadingData<Item, IdType> {

  private cancelPreviousGetCalls$ = new Subject<void>();

  loadItems(): Observable<Item[]> {
    return this.createGetCallObservable();
  }

  getInitialItems(): Observable<Item[]> {
    if (this.peekItems()?.length) {
      return EMPTY;
    }
    return this.loadItems();
  }

  protected abstract getCall(): Observable<Item[]>;

  protected createGetCallObservable(): Observable<Item[]> {
    this.cancelPreviousGetCalls$.next();
    this.pokeIsLoading(true);

    return this.getCall().pipe(
      map(items => {
        this.pokeItems(items);
        return items;
      }),
      takeUntil(this.cancelPreviousGetCalls$),
      catchError(error => {
        this.pokeIsLoading(false);
        return throwError(() => error);
      }),
      finalize(() => this.pokeIsLoading(false))
    );
  }
}
